<template>
  <div>
    <NuxtLink
      :to="{ name: 'app-conversation-id', params: { id: message.conversation } }"
      class="flex items-start cursor-pointer transition py-3 pl-3.5 space-x-3 pr-3 shadow-md bg-white text-light-950 border border-charcoal-300/30 dark:bg-dark-800 dark:border-dark-400/30 dark:text-dark-50 rounded-xl w-full sm:w-96"
      v-if="message"
    >  
      <div class="grow">
        <div class="text-base leading-tight line-clamp-2">
          {{ conversationContent }}
        </div>

        <p class="text-2xs font-medium mt-0.5">
          {{ dayjs(message?.createdAt).fromNow() }}
        </p>
      </div>
      
      <UserPicture
        class="shrink-0"
        size="sm"
        :user="message.owner"
        v-if="message?.owner"
      />
    </NuxtLink>
    <NotificationItem
      class="shadow-md bg-white text-light-950 border border-charcoal-300/30 dark:bg-dark-800 dark:border-dark-400/30 dark:text-dark-50 rounded-xl w-full sm:w-96" :notification="extra.notification"
      v-else-if="(type === 'notification') && extra?.notification && isVisible"
      @click.native="onClick"
    />
    <div class="text-sm shadow-md rounded-xl px-4 py-3 min-h-[60px] flex items-center w-full sm:w-[320px]" :class="type == 'success' ? 'bg-emerald-100 text-emerald-600' : 'bg-ruby-600 text-white'" @click="onClick" v-else-if="isVisible">
      <ChipRound class="mr-3 align-middle mt-0.5 shrink-0" :class="type == 'success' ? 'bg-emerald-600 !text-white' : '!bg-white !text-ruby-600'">
        <IconBase :name="type == 'success' ? 'cute/check' : 'cute/cross'" :width="14" />
      </ChipRound>

      <div>
        <p class="font-medium">{{ content }}</p>
        <p class="text-xs" v-if="description">{{ description }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import ToastsStore from '@/store/toasts'
import { ConversationMessage, IUser } from '@/classes'
import { VIBES } from '@/static/vibes'
import dayjs from 'dayjs'

const props = withDefaults(defineProps<{
  id: string | number
  content: string
  description?: string
  message?: ConversationMessage & {
    owner: IUser
  }
  type?: 'notification' | 'success' | 'failure'
  extra?: any
}>(), {
  type: 'success'
})

const toastStore = ToastsStore()

const isVisible = ref(true)
const route = useRoute()

const conversationContent = computed(() => {
  if (!props.message) return ''

  const content = []
  content.push(`${props.message?.owner?.name} :`)
  
  if (props.message.attachments?.gif) {
    content.push(useNuxtApp().$i18n.t('components.Message.preview.gif'))
  } else if (props.message.attachments?.audio) {
    content.push(useNuxtApp().$i18n.t('components.Message.preview.audio'))
  } else if (props.message.type === 'vibe') {
    const vibeId = props.message.content
    const vibe = VIBES[vibeId]
    content.push(vibe ? useNuxtApp().$i18n.t('components.User.vibes.' + vibeId) + ' ' + vibe?.emoji : useNuxtApp().$i18n.t('components.Message.preview.vibe'))
  } else if (props.message.type === 'friend') {
    content.push(useNuxtApp().$i18n.t('components.Message.preview.friend'))
  } else if (props.message.type === 'match') {
    content.push(useNuxtApp().$i18n.t('components.Message.preview.match'))
  } else {
    content.push(stripTags(props.message.content) || useNuxtApp().$i18n.t('components.Message.preview.message'))
  }

  return content.join(' ')
})

onMounted(() => {
  if (props.message?.conversation && route.name === 'app-conversation-id' && route.params.id === props.message?.conversation) {
    isVisible.value = false
    toastStore.remove(props.id)
  }

  setTimeout(() => {
    isVisible.value = false
    toastStore.remove(props.id)
  }, props.type === 'notification' ? 4000 : 3000)
})

const onClick = () => {
  isVisible.value = false
}

</script>